import { DpCouponCard } from '@/components/blocks/DpLibrary/DpCouponCard';
import { DpMemberPromotionRender } from '@/components/blocks/DpMemberPromotionRender';
import { formatCouponDate } from '@/components/blocks/DpRepurchaseCoupon/formatCouponDate';
import { ContentRecommendation } from '@/components/content/ContentRecommendation';
import { useUser } from '@/data/User';
import {
	buildDppLandingHref,
	getDppFirstName,
	getDppRedeemableTimeLeft,
} from '@/utils/dppPromotion';
import { Box } from '@mui/material';

type DpDppCouponCardProps = {
	href?: string;
	button?: string;
	fallbackcontent?: string | null;
};

/**
 * Tarjeta del cupón DPP para el grid del listado de productos; ocupa la celda de un producto.
 * Sin cupón que se pueda usar, muestra el espot de fallbackcontent o nada si no se envía.
 */
export const DpDppCouponCard = ({ href, button, fallbackcontent = null }: DpDppCouponCardProps) => {
	const { user } = useUser();
	const firstName = getDppFirstName(user?.firstName);
	// Un atributo vacío en el HTML llega como true, no como string.
	const emsName = typeof fallbackcontent === 'string' ? fallbackcontent.trim() : '';
	const fallback = emsName ? (
		<ContentRecommendation
			id={emsName}
			properties={{ emsName }}
			withoutFrame
			loadingElement={<Box />}
		/>
	) : null;

	return (
		<DpMemberPromotionRender
			emptyElement={fallback}
			renderData={(promotion) => {
				const remaining = getDppRedeemableTimeLeft(promotion);
				if (!promotion.eligibleUntil || !remaining) {
					return fallback;
				}
				return (
					<DpCouponCard
						name={firstName}
						discount={`${promotion.discountPercent}%`}
						remaining={remaining}
						expiration={formatCouponDate(promotion.eligibleUntil)}
						button={button}
						href={href ? buildDppLandingHref(href, promotion, firstName) : undefined}
					/>
				);
			}}
		/>
	);
};
